import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateReclamationComponent } from './composants/create-reclamation/create-reclamation.component';
import { DetailrecComponent } from './composants/detailrec/detailrec.component';

const routes: Routes = [
{ path: 'create-reclamation/:id', component: CreateReclamationComponent,  
},
{ path: 'open-detail/:id/:date', component: DetailrecComponent,   
},
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReclamationRoutingModule { }
